<div class="modal-header" id="data-maintenance-system-config-modal-title">
    <h3 class="modal-title" translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_SYSCONFIG_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" tabindex="0">
    <form [formGroup]="dataMaintenanceSysConfigForm">
        <fieldset formArrayName="formChildren">
            <div class="container-fluid">
                <div class="row table-header fw-bold py-2">
                    <div class="col-1"></div>
                    <ng-container *ngFor="let column of model.tableModel.options.columns; last as isLast">
                        <div [ngClass]="isLast ? 'col-3' : 'col-4'">
                            <span (click)="doSort(column.field)">{{ column.title }}</span>
                            <fa-icon
                                *ngIf="reverseSort && orderByField === column.field && model.tableModel.rows.length > 0"
                                [icon]="faSortDown"
                            ></fa-icon>

                            <fa-icon
                                *ngIf="
                                    !reverseSort && orderByField === column.field && model.tableModel.rows.length > 0
                                "
                                [icon]="faSortUp"
                            ></fa-icon>
                        </div>
                    </ng-container>
                </div>

                <div
                    *ngIf="model.tableModel.rows.length === 0"
                    class="text-center"
                    translate="SORTABLE_LIST_EMPTY_TEXT_PLACEHOLDER"
                ></div>

                <ng-container *ngIf="model.tableModel.rows.length > 0">
                    <ng-container *ngFor="let row of model.tableModel.rows | orderBy: orderByField : reverseSort">
                        <pace-data-maintenance-sysconfig-expandable
                            [model]="model.tableModel"
                            [formChildren]="formChildren"
                            [technicalIdOrFunctionalLocationLabel]="strings.technicalIdOrFunctionalLocationLabel"
                            [displayReasonText]="displayReasonText"
                            (modelValueChangedEvent)="modelValueChanged($event)"
                            [row]="row"
                            [columns]="model.tableModel.options.columns"
                        ></pace-data-maintenance-sysconfig-expandable>
                    </ng-container>
                </ng-container>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button
        *ngIf="!isLoading"
        class="btn btn-primary"
        [disabled]="checkRowValidity() || !valueChanged"
        (click)="submit()"
    >
        {{ strings.footer }}
    </button>
    <progressbar type="default" *ngIf="isLoading" [striped]="true" [value]="100">Sending request...</progressbar>
</div>
